import { FileAttachment } from "../../shared/models/file-attachment.model";

export class CategoryModule {
    CategoryId: number = 0;
    CategoryName: string;
    CategoryDescription: string;
    CreatedBy: number;
    ModifiedBy: number;
    CategoryNameId:number;
    CategoryDescriptionId:number;
    IsDelete: boolean = false;

}

export class CategoryRuleData {
    RuleId: number = 0;
    RuleName: string;
    RuleDetails: number;
    CategoryFiles: FileAttachment[] = [];
    CategoryId: number;
    IsActive: boolean = true;
    UserId: number;
    RuleInfoDetails: CategoryRuleInfo[] = [];
}

export class CategoryMappingData {
    CategoryMappingId: number = 0;
    ModuleId: number;
    RiskManagementToolId:number=0;
    CategoryId: any[];
    IsActive: boolean;
    SelectedCategory: boolean = false;
}

export class CategoryRuleInfo {
    CategoryRuleFileName: string;
    CategoryRuleFileURL: string;
}
